module.exports = __webpack_public_path__ + "img/ctrl-aggregate-stub-down-+.5603fe90.svg";